import React from 'react';
import CouponCard from '../../../../components/coupon-codes/CouponCard';
import FeatureItem from '../../../../components/coupon-codes/FeatureItem';
import { ButtonWithAnchor } from '../../../../components/income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../../../components/Atoms/Button';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { b2cData } from '../../../../components/cms/layout/components/header';
import { Meta } from '../../../../layout/Meta';
import {
  expertPlans,
  diyPlans,
} from '../../../../components/coupon-codes/constants';
import { GetStaticProps } from 'next';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { returnNoProps } from '../../../../utils/UtilFunctions';

const CouponPage = () => {
  return (
    <>
      <ClearInNavbar data={b2cData} showPlanVariant={'variantA'} />
      <Meta
        title={
          'ClearTax Coupon Code 2024: Promo Code &amp; Offers for ClearTax ITR Filing'
        }
        description={
          'ClearTax Coupon Code 2024: Get exclusive offers and promo codes for assisted tax filing online. Save on ClearTax ITR filing with discount coupon codes.'
        }
        canonical={'https://cleartax.in/s/coupon-codes'}
        keywords={
          'cleartax promo code, cleartax offers, cleartax discount coupon code, cleartax first time coupon code, cleartax filing coupon code, coupon code cleartax, coupon code for cleartax'
        }
        img="https://assets.clear.in/cleartax/images/1753522630_diy_itrhomepage.png"
      />
      {/* SEO Header */}

      <div className="bg-white py-8 wg-container">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900 text-center">
            ClearTax Coupon Codes
          </h1>
        </div>
      </div>
      <div className="min-h-screen flex flex-row-reverse wg-container">
        {/* Hero Section */}
        <div className="bg-white w-2/5 sm:hidden">
          <div className=" bg-brand-100 shadow-sm border-b mx-auto px-4 sm:px-6 lg:px-8 py-8 sticky top-20 w-3/4">
            <div className="mb-8 text-center">
              <h2 className="text-s-20 font-semibold text-gray-900 mb-4">
                Tax filing simplified
              </h2>

              <div className="grid grid-cols-1 gap-6 mb-8">
                <FeatureItem text="File tax return under 3 minutes" />
                <FeatureItem text="Platform for any type of income tax filing" />
                <FeatureItem text="100% secure & accurate filing" />
              </div>

              <div className="inline-block">
                <ButtonWithAnchor
                  buttonText="Start your Tax Return"
                  buttonLink="https://cleartax.in/filing"
                  trackLabel="itr_organic_2025_coupon_code_page"
                  buttonVariant={ButtonVariants.bluebordered}
                />
              </div>
            </div>

            <div className="text-center mb-8">
              <h3 className="text-s-20 font-semibold text-gray-900 mb-4">
                ClearTax is trusted by 6M+ Indians to file taxes
              </h3>

              <div className="grid grid-cols-1 gap-6 mb-8">
                <FeatureItem text="Your data is safe" />
                <FeatureItem text="24x7 tax expert support" />
                <FeatureItem text="100% paperless" />
              </div>

              <div className="flex justify-center">
                <img
                  src="https://cdn.prod.website-files.com/6093bce33d9b4bae841b04e3/6447972d8da47b141a3920a8_iso.svg"
                  alt="ISO Certification"
                  className="h-12"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Coupons Section */}
        <div className="w-3/5 sm:w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Expert Assisted Plans */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Expert Assisted Plans
            </h2>

            <div className="grid grid-cols-1 gap-8">
              {expertPlans.map((plan, index) => (
                <CouponCard
                  key={index}
                  title={plan.title}
                  couponCode={plan.couponCode}
                  validTill={plan.validTill}
                  buyNowUrl={plan.buyNowUrl}
                  knowMoreLink={plan.knowMoreLink}
                />
              ))}
            </div>
          </div>

          {/* Self Filing Plans */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Self Filing Plans
            </h2>

            <div className="grid grid-cols-1 gap-8">
              {diyPlans.map((plan, index) => (
                <CouponCard
                  key={index}
                  title={plan.title}
                  couponCode={plan.couponCode}
                  validTill={plan.validTill}
                  buyNowUrl={plan.buyNowUrl}
                  knowMoreLink={plan.knowMoreLink}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default CouponPage;
